import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE_TASK_OVERVIEW_MODAL:
    'common/modals/taskOverviewModal/CLOSE_TASK_OVERVIEW_MODAL',
  FETCH_TASKS_ERROR: 'common/modals/taskOverviewModal/FETCH_TASKS_ERROR',
  FETCH_TASKS_REQUEST: 'common/modals/taskOverviewModal/FETCH_TASKS_REQUEST',
  FETCH_TASKS_SUCCESS: 'common/modals/taskOverviewModal/FETCH_TASKS_SUCCESS',
  OPEN_TASK_OVERVIEW_MODAL:
    'common/modals/taskOverviewModal/OPEN_TASK_OVERVIEW_MODAL',
  TASKS_PAGINATE: 'common/modals/taskOverviewModal/TASKS_PAGINATE',
};

export const fetchTasks = {
  request: () => ({
    type: types.FETCH_TASKS_REQUEST,
  }),
  success: ({ openTaskCount, openTasks }) => ({
    type: types.FETCH_TASKS_SUCCESS,
    payload: { openTaskCount, openTasks },
  }),
  error: notify((error) => ({
    type: types.FETCH_TASKS_ERROR,
    payload: { error },
  })),
};

export const taskOverviewModal = {
  close: () => ({
    type: types.CLOSE_TASK_OVERVIEW_MODAL,
  }),
  open: ({ quoteNumberWithRevision }) => ({
    type: types.OPEN_TASK_OVERVIEW_MODAL,
    payload: { quoteNumberWithRevision },
  }),
};

export const tasksPaginate = {
  paginate: ({ pageNumber }) => ({
    type: types.TASKS_PAGINATE,
    payload: { pageNumber },
  }),
};
